import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { NoteBlank, Note } from '@phosphor-icons/react'

import { CREATE_FROM } from '../../helpers'

const SelectCreateInspectionFrom = ({
  onNext = () => {},
  onBack = () => {},
  onSelect = () => {},
  value = '',
}) => {
  const { t } = useTranslation(['internal-inspections', 'common'])
  const options = [
    {
      name: CREATE_FROM.BLANK,
      title: t('internal-inspections:selectCreateFrom.createFromBlank'),
      description: t('internal-inspections:selectCreateFrom.createFromBlankDesc'),
      icon: <NoteBlank />,
    },
    {
      name: CREATE_FROM.TEMPLATE,
      title: t('internal-inspections:selectCreateFrom.createFromTemplate'),
      description: t('internal-inspections:selectCreateFrom.createFromTemplateDesc'),
      icon: <Note />,
    },
  ]

  return (
    <React.Fragment>
      <div className="inspections-modal-content">
        <div className="inspections-card-items">
          <div className="inspections-card-items__wrapper">
            {options.map((option) => (
              <div
                onClick={() => onSelect(option.name)}
                className={`inspections-card-item ${option.name === value ? 'selected' : ''}`}
                key={option.name}
              >
                {option.icon}
                <span>{option.title}</span>
                <span>{option.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="inspections-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary auto-width" onClick={onNext} disabled={!value}>
          {t('internal-inspections:shared.next')}
        </button>
      </div>
    </React.Fragment>
  )
}

SelectCreateInspectionFrom.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onSelect: PropTypes.func,
  value: PropTypes.string,
}

export default SelectCreateInspectionFrom
